import Validator from '@common/lib/validator';

const linkedinRegex = new RegExp(/^(https?:\/\/)?(www\.)?linkedin\.com/i);

export const validators = {
  linkedinForm: () => {
    const schema = {
      post_link: {
        required: true,
        isValid: (
          value,
        ) => linkedinRegex.test(value),
        pattern: linkedinRegex,
        message: 'Please enter a valid Linkedin url',
      },
    };
    const validator = new Validator(schema);
    return validator;
  },
};
